import * as React from 'react';
import { Form, Text, Select, TextArea } from 'react-form';
import { SingleDatePicker } from 'react-dates';
import { api } from '@src/services/api';
import { checkLevel } from "@src/services/user";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoEdit, PropsEdit, StateEdit } from '@src/components/Proto';
import { Box, Modal } from '@src/components';

// typing
interface LocalProps extends PropsEdit {
}
interface LocalState extends StateEdit {
    focused: any;
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Device extends ProtoEdit<LocalProps, LocalState> {
    
	// render
	render() {
        const loading = this.loading();
        if (loading) return null;
        const { id, onCancel } = this.props;
        const { data, values = {}, entity = null, error } = this.state;
        if (entity === null) return null;

        const customers = data.customers.map( v => ({ value: v.id, label: v.name }));
        const batteries = data.batteries.map( v => ({ value: v.id, label: v.name }));
        
        return (
            <Modal
                title={!id ? _('new_title', 'SettingsDevice') : _('edit_title', 'SettingsDevice', { name: entity.description } ) }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.save(v)}
                        defaultValues={{
                            ...entity,
                            battid: entity && entity.battery ? entity.battery.id : null
                        }}
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                        >
                            <div className="fields">
                                {!id &&
                                <>
                                <article>
                                    <label htmlFor="serialno">{_('field_serialno', 'SettingsDevice')}</label>
                                    <Text field="serialno" id="serialno" className="form-control" />
                                </article>
                                <article className="full">
                                    <label htmlFor="description">{_('field_description', 'SettingsDevice')}</label>
                                    <TextArea field="description" id="description" className="form-control" />
                                </article>
                                </>
                                }
                                {/*checkLevel('dealer') &&
                                <article>
                                    <label htmlFor="ownercustid">{checkLevel('hyster') ? _('field_ownercustid_dealer', 'SettingsDevice') : _('field_ownercustid_customer', 'SettingsDevice') }</label>
                                    <Select field="ownercustid" id="ownercustid" options={customers} className="form-control" />
                                </article>
                                */}
                                {/*
                                <article>
                                    <label htmlFor="battid">{_('field_battid', 'SettingsDevice')}</label>
                                    <Select field="battid" id="battid" options={batteries} className="form-control" />
                                </article>
                                */}
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                {_(`btn_cancel`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_save`, 'Settings')} 
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/Device.tsx